import { Injectable } from '@angular/core';

@Injectable()
export class ClipboardService {

  constructor() {
  }

  copy(text: string): boolean {
    const textarea = document.createElement('textarea');

    textarea.style.position = 'fixed';
    textarea.style.top      = '0';
    textarea.style.left     = '0';
    textarea.style.opacity  = '0';
    textarea.value          = text;

    document.body.appendChild(textarea);
    textarea.select();

    let success = false;

    try {
      success = document.execCommand('copy');
      textarea.remove();
    } catch (err) {
      console.log('Oops, unable to copy');
    }

    return success;
  }

}
